import { ToastTypes } from "../pages/ShieldStarter/Components/Toast";

export const ZERO_CASH_PAYMENT_NOTIFICATION = {
  type: ToastTypes.INFO,
  title: "No cash payment required.",
  description:
    "The premium will be deducted from your CPF MediSave account 1 to 2 weeks from your application date.",
};

export const PAYMENT_ERROR_NOTIFICATION = {
  type: ToastTypes.ERROR,
  title: "Payment unsuccessful. ",
  description: "We were not able to make the transaction, kindly try again.",
};

export const NO_RIDER_NOTIFICATION = {
  type: ToastTypes.INFO,
  title: "You have not added the Singlife Health Plus Starter rider yet.",
  description: `Edit your "Plan Summary" to add this rider, which reduces mandatory co-payments to just 5% of your hospital bills. You'll not be able to add it after you submit your application.`,
};

export const INCORRECT_ADVISER_NOTIFICATION = {
  type: ToastTypes.ERROR,
  title: "Incorrect adviser code.",
  description: `Close the browser and try again with another code or continue without an adviser code.`,
};
